import { MaintenanceObjectiveActionsData } from "../types/MaintenanceObjectiveActions.type";
import ActionLinkButton from "@/common/components/ActionLinkButton";

export class MaintenanceObjectiveActionsTransformer {

  static tableTransformer() {
    return (objectiveParts: MaintenanceObjectiveActionsData[]) => {
      return objectiveParts.map((objectiveParts) => {
        return {
          ...objectiveParts,
          actions: (
            <ActionLinkButton
              linkTo={objectiveParts.id}
              operationKlassToCheckPermission="Admin::Maintenance::ObjectiveActions::Show"
              dataTestid="show_button"
            />
          ),
        }
      });
    }
  }

}
